import { render, staticRenderFns } from "./LegacyPieChartWidget.vue?vue&type=template&id=2ad9ea54&scoped=true&"
import script from "./LegacyPieChartWidget.vue?vue&type=script&lang=js&"
export * from "./LegacyPieChartWidget.vue?vue&type=script&lang=js&"
import style0 from "./LegacyPieChartWidget.vue?vue&type=style&index=0&id=2ad9ea54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad9ea54",
  null
  
)

export default component.exports